<template>
    <div class="radiogram-container">
        <ul class="node-cell" v-if="bizTopicList != null && bizTopicList.length > 0">
            <li class="node-item" v-for="bizTopic in bizTopicList">
                <span>主题 - {{bizTopic.name}}</span>
                <ul class="node-children">
                    <li class="node-item" v-for="subscrEventMsg in bizTopic.subscrEventMsgList">
                        <span>事件 - {{subscrEventMsg.name}}</span>
                        <ul class="node-children">
                            <li class="node-item" v-for="subscrEventCom in subscrEventMsg.subscrEventComList">
                                <span>公司 - {{subscrEventCom.name}}</span>
                                <ul class="node-children">
                                    <li class="node-item" v-for="subscrGoodsCat in subscrEventCom.subscrGoodsCatList">
                                        <span>商品分类- {{subscrGoodsCat.name}}</span>
                                    </li>
                                    <li class="node-item" v-for="subscrServcCat in subscrEventCom.subscrServcCatList">
                                        <span>服务分类- {{subscrServcCat.name}}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="no-data" v-else>
            <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
            <span class="">暂无订阅消息</span>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import bizMsgApi from '../../api/bizMsg'
    //
    export default {
        name: 'swb-show-biz-event-subscr-list',
        props: ['staffId'],
        desc: '查看已订阅消息',
        data: function () {
            return {
                bizTopicList: [],
                //
                miniAppAliases: {}
            }
        },
        created: function () {
            this.miniAppAliases = {
                "retailerPurch": "零售商采购管理",
                "retailerAsset": "零售商资产管理",
                "retailerAssist": "零售商门店小助手"
            };
            // 获取已订阅消息
            this.getTopicSubscrList();
        },
        methods: {
            getTopicSubscrList(){
                let self = this;
                let postData = {};
                postData.staffId = this.staffId;
                //
                let theLoading = MsgBox.loading();
                bizMsgApi.getTopicSubscrList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        //
                        self.bizTopicList = result.data;
                        //
                        console.log(JSON.encode(self.bizTopicList));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 取消订阅
            cancleMsgSubscr: function (id) {
                let self = this;
                self.$confirm('确定取消该订阅吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    let postData = {};
                    postData.id = id;
                    bizMsgApi.deleteBizEventMsgById(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.getBizEventMsgSubscrList();
                            //
                            MsgBox.success('取消订阅成功！');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizMsg/ShowSubscrList.vue